<template>
  <div class="Invest">
    <h3 class="mb-3 text-right">colocaciones registradas</h3>
    <b-card>
      <b-container fluid>
        <!-- User Interface controls -->
        <b-row align-v="center" align-h="between">
          <b-col sm="6" md="6" cols="10" lg="5" class="my-1">
            <b-form-group
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
              class="mb-0"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Buscar"
                ></b-form-input>
                
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col sm="6" md="6" cols="12" lg="5" class="my-1">
            <b-form-group
              label="Por Página"
              label-cols-sm="6"
              label-cols-md="3"
              label-cols-lg="4"
              label-align-sm="right"
              label-size="sm"
              label-for="perPageSelect"
              class="mb-0"
            >
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="md"
                :options="pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Main table element -->
        <b-table
          show-empty
          small
          stacked="md"
          class="text-left"
          style="font-family: Montserrat; font-weight: lighter; font-size: 14px"
          id="my-table"
          :items="InvestTmp"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          :busy="isBusy"
        >
          <template v-slot:empty>
            <div class="mt-2 text-center">
              <h6>No hay colocaciones registrados</h6>
            </div>
          </template>

          <template v-slot:table-busy>
            <div class="text-center text-dark my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Cargando...</strong>
            </div>
          </template>

          <template v-slot:emptyfiltered>
            <div class="my-2 text-center">
              <h6>No hay colocaciones con esas especificaciones</h6>
            </div>
          </template>
          <template v-slot:cell(amount)="row"> $ {{ row.value }} </template>
          <template v-slot:cell(status_payment_id)="row">
            <p v-if="row.value == 1">Pendiente</p>
            <p v-if="row.value == 2" style="color: green">
              Aprobado <v-icon name="check-circle"></v-icon>
            </p>
            <p v-if="row.value == 3" color="#CF173C">
              Rechazado <v-icon name="times-circle"></v-icon>
            </p>
            <!-- {{
            row.value == 1 ? "Pendiente" : row.value == 2 ? "Aprobada" : "Rechazada"
          }} -->
          </template>

          <template v-slot:cell(actions)="row">
            <!-- <b-button title="Detalles" size="sm" variant="white">
              <v-icon name="clipboard-list"></v-icon>
            </b-button> -->

            <b-button
              title="Aprobar"
              size="sm"
              variant="white"
              v-if="row.item.status_payment_id == 1"
              @click="changeStatus(row.item.id, 2)"
            >
              <v-icon name="check-circle" color="green"></v-icon>
            </b-button>
            <b-button
              title="Rechazar"
              size="sm"
              variant="white"
              v-if="row.item.status_payment_id == 1"
              @click="changeStatus(row.item.id, 3)"
            >
              <v-icon name="times-circle" color="#CF173C"></v-icon>
            </b-button>

            <!-- <b-button
              title="Eliminar"
              size="sm"
              class="mr-1"
              variant="white"
              v-if="row.item.status_payment_id != 1"
              @click="deleteInvestource(row.item)"
            >
              <v-icon v-show="!hide" name="trash" color="#CF173C"></v-icon>
              <b-spinner
                v-show="hide"
                small
                variant="danger"
                class="align-middle"
              ></b-spinner>
            </b-button> -->
          </template>
        </b-table>
        <b-col lg="5" class="mx-auto pt-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="md"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "Invest",
  data() {
    return {
      progress: false,
      test: true,
      test1: false,
      hide: false,
      isBusy: false,
      InvestTmp: [],
      Invest: [],
      fields: [
        {
          key: "account.user.first_name",
          label: "Nombre",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "account.name",
          label: "Cuenta",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "account.user.email",
          label: "Correo electrónico",
          sortable: true,
        },
        {
          key: "amount",
          label: "Monto",
          sortable: true,
        },
        {
          key: "created_at",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "status_payment_id",
          label: "Estado del depósito",
          sortable: true,
        },
        { key: "actions", label: "Acciones" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
    }),
  },
  mounted() {
    this.getDataInvest();
  },
  methods: {
    ...mapActions([
      "getAllInvest",
      "UserUpdate",
      "changeactivateUser",
      "changePayStatus",
    ]),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getDataInvest() {
      this.isBusy = true;
      this.getAllInvest()
        .then((response) => {
          if (response.code == 200) {
            this.InvestTmp = response.data;
            this.totalRows = response.data.length;
            this.isBusy = false;
          }
        })
        .catch((error) => {
          console.log(error);
          alert("Ocurrió un error, intente más tarde");
        });
    },
    changeStatus(pay, stats) {
      let stat = stats === 2 ? "aprobar" : "rechazar";
      Swal.fire({
        title: "Atención",
        text: "¿Estás seguro que deseas " + stat + " esta inversión?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#121419",
        reverseButtons: true,
        confirmButtonText: "Sí, seguro",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          let status =
            stats === 2
              ? "Se ha aceptado la inversión"
              : "Se ha rechazado la inversión";
          let form = {
            id: pay,
            status: stats,
          };
          Swal.showLoading();
          this.changePayStatus(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: status,
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });
                this.getDataInvest();
              }
            })
            .catch((error) => {
              console.log(error);
              alert("Ocurrió un error, intente más tarde");
              this.getDataInvest();
            });
          console.log(form);
        }
      });
    },
    UpdateUser() {
      if (
        this.name != null &&
        this.last_name != null &&
        this.country != null &&
        this.phone != null
      ) {
        if (this.country == "Venezuela" && this.city == null) {
          Swal.fire({
            title: "¡Atención!",
            text: "Debe seleccionar un estado",
            icon: "warning",
          });
        } else {
          this.progress = true;
          if (this.country != "Venezuela") {
            this.city = "";
          }
          let form = {
            id: this.id,
            params: {
              first_name: this.name,
              last_name: this.last_name,
              country: this.country,
              email: this.email,
              state: this.city,
              phone: this.phone,
            },
          };
          this.UserUpdate(form).then((response) => {
            if (response.code == 200) {
              Swal.fire({
                title: "Listo",
                text: "Sus datos han sido actualizados",
                icon: "success",
              });
              this.progress = false;
              this.getDataUser();
            } else {
              this.progress = false;

              Swal.fire({
                title: "Error",
                text: "",
                icon: "warning",
              });
            }
          });
        }
      } else {
        Swal.fire({
          title: "¡Atención!",
          text: "No puede dejar campos vacios",
          icon: "warning",
        });
      }
    },
  },
};
</script>
<style scoped>
</style>